import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import { Link } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import { EditIcon, TrashIcon, UploadIcon } from "../../components/SVGIcon";
import VideoPopupLightbox from "../../components/VideoPopupLightbox";


function isEmpty(obj) {
  // Check for null or undefined before accessing properties
  if (obj === null || typeof obj !== 'object') {
    return false; // Or handle as appropriate for your use case
  }
  return Object.keys(obj).length === 0;
}

const extractFileName = (url) => {
  console.log("asdasdasdasdasdasd", url);
  let lastPart = "";
  if (url && url?.url) {
    lastPart = url?.url?.substring(url?.url?.lastIndexOf("/") + 1);
  } else {
    lastPart = url?.substring(url?.lastIndexOf("/") + 1);
  }
  const fileName = lastPart.substring(lastPart.indexOf("_") + 1);
  return lastPart || "";
};

export const AttachmentsSectionSchema = {
  name: "Attachments",
  tag: "Attachments",
  fields: [
    {
      type: "ArrayOfAttachments",
      name: "Attachments",
      value: ["", "", "", ""],
    },
  ],
};



const normalizeAttachments = (arr = []) => {
  const cleaned = [...arr];

  // // Remove trailing empty items
  // while (
  //   cleaned.length &&
  //   (!cleaned[cleaned.length - 1] ||
  //     !cleaned[cleaned.length - 1]?.message ||
  //     !cleaned[cleaned.length - 1]?.file)
  // ) {
  //   cleaned.pop();
  // }


  return cleaned;
};



const AttachmentsSection = ({
  // singleDefaultElementTypes,
  // templateJson,
  // handleSectionNameChange,
  // isCreateReportRoute,
  // setTemplateJson,
  // section,
  // index,
  markSectionEditing,
  updateSection,
  section,
  isCreateReportRoute
}) => {
  const [isEditModeOn, setIsEditModeOn] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [localSectionName, setLocalSectionName] = useState("");
  const [fields, setFields] = useState([]);
  const [localFields, setLocalFields] = useState([]);

  const handleEditStart = () => {
    setLocalFields(fields);
    setLocalSectionName(section?.name || "");
    setIsEditModeOn(true);
  };

  console.log("aaasec",section)
  const exitEditMode = () => {
    setIsEditModeOn(false);
  };

  useEffect(() => {
    if (!section?.id) return;
    markSectionEditing(section.id, isEditModeOn);
  }, [isEditModeOn, section?.id, markSectionEditing]);

  // useEffect(() => {
  //   setFields(section?.fields ?? []);
  //   setLocalFields(section?.fields ?? []);
  //   setLocalSectionName(section?.name || "");
  // }, [section]);
  useEffect(() => {
  const normalizedFields =
    section?.fields?.map(field => {
      
      if (field.type === "ArrayOfAttachments") {
        let value = Array.isArray(field.value) ? [...field.value] : [];
        
    
        value = value.map(v => {
          
          if (!v) return {};
          if (typeof v === "string") return v ? { url: v } : {};
          return v;
        });
        
        // -----------------------------
        // EDIT MODE → ALWAYS KEEP ONE EXTRA EMPTY SLOT
        // -----------------------------
        if (isEditModeOn) {
          const last = value[value.length - 1];

          // If last has url / message / file → push empty {}
          if (last?.url || last?.file || last?.message) {
            value.push({});
          }

          // If list is empty → ensure at least one {}
          if (!value.length) value.push({});
        }

        // -----------------------------
        // VIEW MODE → remove trailing empties only  when isCreateReport is true not in template
        // -----------------------------
        if (!isEditModeOn && isCreateReportRoute) {
          while (
            value.length &&
            (!value[value.length - 1]?.url &&
              !value[value.length - 1]?.file &&
              !value[value.length - 1]?.message)
          ) {
            value.pop();
          }
        }

        return {
          ...field,
          value
        };
      }

      return field;
    }) ?? [];

  setFields(normalizedFields);
  setLocalFields(normalizedFields);
  setLocalSectionName(section?.name || "");
}, [section, isEditModeOn]);


  



  const handleDeleteSection = () => {
    updateSection(section.id, null); // parent removes
    setShowModal(false);
  };

  // CANCEL – discard local changes
  const handleCancel = () => {
    setLocalFields(fields);
    setLocalSectionName(section?.name || "");
    setIsEditModeOn(false);
  };

  const handleSaveUpdate = () => {
    updateSection(section.id, prev => ({
      ...prev,
      name: localSectionName,
      fields: [...localFields],
    }));
    exitEditMode();
  };

  const handleAttachmentUpload = (e, row, index) => {
  const file = e.target.files?.[0];
  if (!file) return;

  const uploaded = {
    url: URL.createObjectURL(file),
    file
  };

  setLocalFields(prev => {
    const copy = structuredClone(prev);
    const field = copy[row];
    if (!field) return prev;

    if (!Array.isArray(field.value)) field.value = [];

    field.value[index] = uploaded;

    // Ensure NEXT EMPTY SLOT EXISTS
    const last = field.value[field.value.length - 1];
    if (last?.url || last?.file || last?.message) {
      field.value.push({});
    }

    return copy;
  });
};


  const getAttachmentUrl = (a) => a?.url ||
    a?.message?.url ||
    a?.file?.name ||
    a?.message || "";

  const getFileName = (a) => {
    const url =
    a?.url ||
    a?.message?.url ||
    a?.file?.name ||
    a?.message || "";
    return extractFileName(url);
  };

  const getAttachmentIcon = (attachment) => {
  if (!attachment || isEmpty(attachment)) return {name: "Attachment", icon: "/images/attachments-placeholder.jpg"};

  const url =
    attachment?.url ||
    attachment?.message?.url ||
    attachment?.file?.name ||
    attachment?.message || "";
  
  
  console.log("asasdasd111",url,attachment);
  const ext = url.split(".").pop()?.toLowerCase() || "";
  const name = url.split("/").pop()?.toLowerCase() || "";

  const videoExt = ["mp4", "mov", "avi", "mkv", "webm"];
  const audioExt = ["mp3", "wav", "aac", "m4a", "ogg"];
  const docExt = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv"];

  if (videoExt.includes(ext)) return {name: name,icon:"/images/file-type-icon-video.svg"};
  if (audioExt.includes(ext)) return {name: name,icon:"/images/file-type-icon-audio.svg"};
  if (docExt.includes(ext)) return {name: name,icon:"/images/file-type-icon-doc.svg"};

  return {name: name,icon:"/images/file-type-icon-doc.svg"};
};



  console.log("fieldsAttacment", localFields)
  return (
    <>
      <div className="d-flex align-items-center justify-content-between gap-3 p-3 border-bottom">
        {/* <h2 className="fs-20 fw-semibold mb-0">Attachments</h2> */}
        {isEditModeOn ? (
          <Form.Control
            type="text"
            value={localSectionName}
            onChange={(e) => setLocalSectionName(e.target.value)}
            className="fs-20 fw-semibold mb-0 border-0 bg-transparent"
            style={{ maxWidth: "400px" }}
          />
        ) : (
          <Form.Control
            type="text"
            readOnly
            value={section?.name || ""}
            // onChange={(e) => setLocalSectionName(e.target.value)}
            // onChange={(e) => handleSectionNameChange(section.id, e.target.value)}
            className="fs-20 fw-semibold mb-0 border-0 bg-transparent"
            style={{ maxWidth: "400px" }}
          />
        )}
        <div className="d-flex align-items-center gap-1">
          {!isEditModeOn && (
            <Button
              variant="icon"
              className="btn-md text-blue-600"
              onClick={handleEditStart}
            >
              <EditIcon />
            </Button>
          )}
          {!isCreateReportRoute && <Button
            variant="icon"
            className="btn-md text-red-600"
            onClick={() => {
              setShowModal(true);
            }}
          >
            <TrashIcon />
          </Button>}
        </div>
      </div>
      <div className="p-3">
        <Row className="g-3">
          {localFields?.map((element, row) => {
            if (element.type === "ArrayOfAttachments") {
              return element?.value?.map((attachmentObject, colIndex) => {
                let iconSrc = getAttachmentIcon(attachmentObject)
                console.log("attachmentObject",attachmentObject)
                // if (attachmentObject?.message_type === 4) {
                //   iconSrc = "/images/file-type-icon-video.svg";
                // } else if (attachmentObject?.message_type === 5) {
                //   iconSrc = "/images/file-type-icon-audio.svg";
                // } else if ([6, 7].includes(attachmentObject?.message_type)) {
                //   iconSrc = "/images/file-type-icon-doc.svg";
                // }

                return (
                  <>
                    <Col md="3" xs="6" key={colIndex}>
                      <div className={`${(attachmentObject?.url || attachmentObject?.message || !isCreateReportRoute) ? 'bg-gray-50' : 'border border-gray-200'} ${isEditModeOn ? 'file-upload-box-dashed' : ''} rounded-3 ratio ratio-1x1 d-block overflow-hidden`}>
                        <div className="d-flex align-items-center flex-column justify-content-center gap-2">
                          {(attachmentObject?.url || attachmentObject?.message || !isCreateReportRoute) ? (
                            <>
                            {isCreateReportRoute && <Link
                              to="Javascript:void(0)"
                              reloadDocument
                              target="_blank"
                            >
                              <Image src={iconSrc?.icon} width="96" height="96" alt="Icon" />
                            </Link> || <Image src={iconSrc?.icon} width="96" height="96" alt="Icon" />}
                            </>
                          ) : (
                            <>
                              {isEditModeOn && <label
                                className="cursor-pointer d-flex align-items-center justify-content-center flex-column gap-3"
                                htmlFor={`attachemnt-upload-${row}-${colIndex}`}
                                >
                                <input
                                  hidden
                                  type="file"
                                  id={`attachemnt-upload-${row}-${colIndex}`}
                                  onChange={(e) => handleAttachmentUpload(e, row, colIndex)}
                                />
                                  <span className="file-upload-icon icon-80">
                                    <UploadIcon size={50} />
                                  </span>
                                  <span className="fs-24 text-gray-500">Upload File</span>
                              </label>}                           
                            </>
                          )}
                        </div>
                      </div>
                      {isEditModeOn && <input className="attachemnt-upload-file form-control mt-2" name={`attachment-${row}-${colIndex}`} value={getAttachmentUrl(attachmentObject)} placeholder="File name will show here once uploaded" />}
                      {(attachmentObject?.url && !isEditModeOn) && <p className="fs-6 text-gray-700 mt-1 mb-0 text-break">{getFileName(attachmentObject)}</p>}
                    </Col>                    
                  </>
                );
              });
            } else {
              return (
                <Col md="3" xs="6" key={row}>
                  <picture className="ratio ratio-1x1 d-block">
                    <Image
                      className="rounded-3"
                      src="/images/image-placeholder.jpg"
                      width={150}
                      height={50}
                      alt="Header Image 1"
                    />
                  </picture>
                </Col>
              );
            }
          })}
          {/* {isEditModeOn && <Col md="3" xs="6" >
              <picture className="ratio ratio-1x1 d-block">
                <Image
                  className="rounded-3"
                  src="/images/image-placeholder.jpg"
                  width={150}
                  height={50}
                  alt="Header Image 1"
                />
              </picture>
            </Col>} */}
        </Row>

      </div>

      {isEditModeOn && (
        <div className="p-3 border-top">
          <Row className="gy-2 gy-sm-0">
            <Col md="8" className="d-flex align-items-center gap-2">
              <Button variant="primary" className="btn-md" onClick={handleSaveUpdate}>
                Save & Update
              </Button>
              <Button variant="outline-secondary" className="btn-md" onClick={handleCancel}>
                Cancel
              </Button>
            </Col>
            <Col md="4" className="text-sm-end">
              <Button
                variant="danger-light"
                className="btn-md"
                onClick={() => {
                  setShowModal(true);
                }}
              >
                Delete Section
              </Button>
            </Col>
          </Row>
        </div>
      )}

      <Modal
        className="info-modal"
        show={!!showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/delete-badge-red.svg" alt="Delete Badge" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Are you sure you want to delete this section?
            </h2>

            <div className="d-flex align-items-center gap-3">
              <Button
                variant="primary"
                className="btn w-100 mt-5"
                onClick={handleDeleteSection}
              >
                Yes, Delete It!
              </Button>
              <Button
                variant="gray"
                className="btn w-100 mt-5"
                onClick={() => setShowModal(false)}
              >
                No, Not Yet
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AttachmentsSection;
